import React, { Component } from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {connect} from 'react-redux';

import ButtonDash from './containers/ButtonDash/ButtonDash';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import Login from './components/Login/Login';
import Report from './containers/Report/Report';

//import Construction from './components/Construction/Construction';

class App extends Component {
  //render(){
  //  return <Construction />;
  //}
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/report" component={Report} />
          <PrivateRoute exact path='/' component={ButtonDash} />
          <Route path="/login" component={Login} />
        </Switch>
      </BrowserRouter>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  const { user } = state.authentication;
    return {
      alert,
      user
  };
}

export default connect(mapStateToProps)(App);
